import { useContext } from "react";
import ChatStateContext from "../context/ChatStateContext";

export const useChatState = () => {
  return useContext(ChatStateContext);
};
